import apiClient from "./api";

const fetch = (page = 0) => {
  return apiClient.get("/admin/customers?page=" + page).then((res) => res.data);
};

const find = (id) => {
  return apiClient.get("/admin/customers/" + id).then((res) => res.data);
};

const remove = (id) => {
  return apiClient.delete("/admin/customers/" + id).then((res) => res.data);
};

const create = (params) => {
  return apiClient.post("/admin/customers", params).then((res) => res.data);
};

const update = (id, params) => {
  return apiClient
    .patch("/admin/customers/" + id, params)
    .then((res) => res.data);
};

const all = (page = 0) => {
  return apiClient.get("/customers-list").then((res) => res.data);
};

export default {
  fetch,
  find,
  create,
  update,
  remove,
  all,
};
